export const navigation = [
  { name : 'About Tango', href : '/about' },
  { name : 'Services', href : '/services' },
  { name : 'Case Studies', href : '/case_studies' },
  { name : 'Careers', href : '/careers' },
  { name : 'Blog', href : 'https://tango.io/blog', target : '_blank' }
];
